
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EmbedVideoService } from 'ngx-embed-video';
import { FirebaseMediaElementModel } from '../data-model/mediaElement.model';

@Component({
  selector: 'app-add-media',
  templateUrl: './add-media.component.html',
  styleUrls: ['./add-media.component.scss']
})
export class AddMediaComponent implements OnInit {

  @Input() mediaElement: FirebaseMediaElementModel = null;
  @Input() mediaId: string = '0';
  @Input() modoVisualizacion: string = 'vista';
  @Output() created: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  public Editor = ClassicEditor;

  constructor(
    private sanitizer: DomSanitizer,
    private embedService: EmbedVideoService,
  ) { }

  ngOnInit(): void {
    console.log(this.mediaElement);
  }

  setType(type) {
    this.mediaElement.type = type;
    this.created.emit();
  }

  getAudio(event) {
    this.getFile(event);
    this.setType('audio');
  }

  getImage(event) {
    this.getFile(event);
    this.setType('image');
  }

  getVideo(event) {
    this.getFile(event);
    this.mediaElement.videoType = 'local';
  }

  getFile(event) {
    var file = event.target.files[0];
    //Pasar el binario y generar el nombre único del archivo para subirlo a Firebase
    this.mediaElement.file = file;
    this.mediaElement.fileName = Date.now() + file.name;
    //Convertir archivo a URL para poder visualizar en modo edición
    this.mediaElement.urlsanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
  }

  setVideoMode(mode) {
    this.mediaElement.videoType = mode;
    this.mediaElement.urlsanitizer = this.embedService.embed(this.mediaElement.url);
  }

  onEditText({ editor }: ChangeEvent){
    console.log(editor.getData());
    this.mediaElement.text=editor.getData();
  }
 
}
